export default function EssentialHero() {
  return (
    <section className="w-full bg-white pt-24 pb-0 border-b border-gray-100">
      <div className="max-w-5xl mx-auto px-6">
        <div className="py-10 flex flex-col md:flex-row md:items-center gap-6">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-4">
              <span
                className="text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full"
                style={{ backgroundColor: 'rgba(46,125,107,0.1)', color: '#2E7D6B' }}
              >
                ESSENTIAL GUIDE
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug mb-3">
              간병인 배정 후{' '}
              <span style={{ color: '#2E7D6B' }}>필수사항</span>
            </h1>
            <div
              className="rounded-xl px-5 py-4 text-sm leading-relaxed"
              style={{ backgroundColor: '#f0f9f6', borderLeft: '4px solid #2E7D6B' }}
            >
              <p className="text-gray-700">
                간병인 배정 이후 보험금 청구를 위해 반드시 지켜야 할 사항들입니다.
                아래 내용을 숙지하지 않으면 보험금 청구가 거절될 수 있으니 꼼꼼히 확인해 주세요.
              </p>
              <p className="text-xs text-gray-500 mt-1">
                간병 시작 전 반드시 확인 · 간병비 이체 규정 · 간병일지 작성 필수
              </p>
            </div>
          </div>
          <div className="flex-shrink-0 flex items-center justify-center">
            <div
              className="w-32 h-32 md:w-40 md:h-40 rounded-2xl flex flex-col items-center justify-center gap-2"
              style={{ backgroundColor: '#f0f9f6', border: '2px solid rgba(46,125,107,0.2)' }}
            >
              <i className="ri-shield-check-line text-4xl md:text-5xl" style={{ color: '#2E7D6B' }}></i>
              <span className="text-xs font-bold text-gray-600 text-center leading-tight px-2">배정 후<br/>필수사항</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
